import { getCaseType } from 'Utils'
import React from 'react'

// Label / value rows for profile details (also used by Statistics).
// Phone: label above value so long emails/links never run off the screen.
// Wider screens: label left, value right.
const withScheme = (v) => (/^https?:\/\//i.test(String(v)) ? String(v) : 'https://' + v);

function RenderProfessionalDetailsGrid({data}) {
  const entries = Object.entries(data || {}).filter(([label]) => label !== '');
  return (
    <div className="w-full flex flex-col font-plexsans">
        {entries.map(([label, value]) => {
          const lower = label.toLowerCase();
          const empty = value === undefined || value === null || value === '' || value === '--';
          let content;
          if (Array.isArray(value)) {
            content = value.length === 0
              ? <span className="font-normal text-navy/[.55]">{lower.includes('case') ? 'All case types (default)' : lower.includes('state') ? 'All states (default)' : 'Not provided'}</span>
              : <span className="flex flex-wrap gap-1.5 sm:justify-end">
                  {value.map((val) => ({ val, text: lower.includes('case') ? getCaseType(val) : val })).filter((c) => c.text).map(({ val, text }) => (
                    <span key={val} className="font-medium text-[12px] leading-none text-navy bg-navy/[.05] border border-navy/[.12] rounded-[5px] py-1.5 px-2 capitalize">
                      {text}
                    </span>
                  ))}
                </span>;
          } else if (empty) {
            content = <span className="font-normal text-navy/[.4]">Not provided</span>;
          } else if (lower.includes('link') || lower.includes('url')) {
            content = <a href={withScheme(value)} target="_blank" rel="noreferrer" className="text-brass underline hover:text-brassDark">{value}</a>;
          } else {
            content = value;
          }
          return (
            <div key={label} className="flex flex-col gap-1 sm:flex-row sm:justify-between sm:items-start sm:gap-6 py-3 border-b border-navy/[.08] last:border-b-0">
              <span className="flex-none sm:w-[40%] text-[12.5px] sm:text-[13.5px] leading-[1.4] text-navy/[.6]">{label}</span>
              <span className="min-w-0 text-[14px] sm:text-[13.5px] leading-[1.4] font-semibold text-navy sm:text-right [overflow-wrap:anywhere]">{content}</span>
            </div>
          );
        })}
    </div>
  )
}

export default RenderProfessionalDetailsGrid
